import { Box, Button } from '@branch-messenger/willow-ui'
import { Edit04 } from '@branch-messenger/willow-ui/icons'
import { FC } from 'react'

import { Alert, AlertBodyText } from '@/components/alert'
import { useDownloadAdvanceAgreement } from '@/queries/ewa'

type AdvanceAgreementProps = {
  buttonText?: string
  description?: string
  transferId: string
}

export const AdvanceAgreement: FC<AdvanceAgreementProps> = ({
  buttonText = 'Download',
  description = 'Download your On-Demand Pay Agreement for this advance.',
  transferId,
}) => {
  const { mutate: downloadAdvanceAgreement } = useDownloadAdvanceAgreement()

  return (
    <Alert Icon={Edit04}>
      <Box $display="flex" $gap={4} $justify="space-between" $flex={1}>
        <Box>
          <AlertBodyText $bold>On-Demand Pay Agreement</AlertBodyText>
          <AlertBodyText>{description}</AlertBodyText>
        </Box>
        <Button
          variant="link"
          onClick={() => downloadAdvanceAgreement(transferId)}
        >
          {buttonText}
        </Button>
      </Box>
    </Alert>
  )
}
